import { Component, OnInit, Input } from '@angular/core';
import { ModalsComponent } from '../modals.component';
import { BsModalRef } from "ngx-bootstrap/modal";
import { ReadAnswerInfo } from '@schoolbelle/api/letter-read';
import { Letter } from '@schoolbelle/api/letter';

@Component({
  selector: 'modal-read-list',
  templateUrl: './read-list-modal.component.html',
  styleUrls: ['./read-list-modal.component.scss'],
  
})
export class ReadListModalComponent extends ModalsComponent implements OnInit {
  @Input() rows:(string|number|ReadAnswerInfo)[][] = [];
  @Input() letter:Partial<Letter>
  

  constructor(
    modalRef:BsModalRef,
  ) {
    super(modalRef);
  }
  ngOnInit () {
  }
}    